import React, { Component } from 'react';
import { request } from 'http';


const Data = [
	{
		icon:require('./img/gmailIcon.png'),
		b:"Gmail",
		k:"gApp0_gmail",
		t:"Gmail is an easy to use email app that saves you time and keeps your messages safe. Get your messages instantly via push notifications, read and respond online & offline, and find any message quickly."
	}, 
	{
		icon:require('./img/chromeIcon.png'),
		b:"Chrome",
		k:"gApp1_chrome",
		t:"Google Chrome is a fast, easy to use, and secure web browser. Designed for Android, Chrome brings you personalized news articles, quick links to your favorite sites, downloads, and Google Search and Google Translate built-in. Download now to enjoy the same Chrome web browser experience you love across all your devices."
	}, 
	{
		icon:require('./img/gMapsIcon.png'),
		b:"Maps - Navigation & Transit",
		k:"gApp2_gMaps",
		t:"Going somewhere? Go with Maps, the official app you can rely on for real-time GPS navigation, traffic, transit, and details about millions of places, such as reviews and popular times."
	}, 
	{
		icon:require('./img/gClndIcon.png'),
		b:"Google Calendar",
		k:"gApp3_gCalendar",
		t:"Get the official Google Calendar app for your Android phone and tablet to save time and make the most of every day."
	},
	{
		icon:require('./img/youtubeIcon.png'),
		b:"YouTube",
		k:"gApp4_youTube",
		t:"Get the official YouTube app for Android phones and tablets. See what the world is watching -- from the hottest music videos to what’s trending in gaming, entertainment, news, and more. Subscribe to channels you love, share with friends, and watch on any device."
	},
	{
		icon:require('./img/googleSearchIcon.png'),
		b:"Google Search",
		k:"gApp6_gSearch",
		t:"The Google app keeps you in the know about the things you care about. Find quick answers, explore your interests, and get personalized updates in your Google feed. The more you use the Google app, the better it gets.",
	}, 
	{
		icon:require('./img/gDocsIcon.png'),
		b:"Google Docs",
		k:"gApp5_gDocs",
		t:"Create, edit and collaborate with others on documents from your Android phone or tablet with the Google Docs app."
	}, 
]
class Row extends Component {
	state = {on: true}
	componentDidMount() {
		this.updateValue()
		this.updateValue = this.updateValue.bind(this)
	}
	updateValue() {
		const {k} = this.props.data
		k && global.setAnswer(k, this.state.on)
	}
	render() {
		const {data} = this.props
		return <div>
			<div style={{
				marginTop: 15,
				display:"flex",
			}}>
				<img src={data.icon} style={{
					width:20,
					height:20,
					marginLeft:20,
					marginTop:5,
					// opacity:0.7
				}} />
				<div style={{
					width: data.noBtn ? 276 : 236,
					marginLeft:20,
					// backgroundColor:"red"
				}}>
					<span style={{
						fontWeight:"bold",
						fontSize: 13,
					}}>{data.b}</span>
					<span style={{
						fontSize:13,				
						// fontWeight:"bold",
					}}> {data.t}</span>
				</div>
				{!data.noBtn && <img src={this.state.on ? require('./img/rOn.png'): require('./img/rOff.png')} 
					onClick={() => this.setState({on:!this.state.on}, this.updateValue)}
					style={{
						cursor:"pointer",
						width:45,
						height:45,
						alignSelf:"center"	

					}}
				/>}
			</div>
			<div style={{
				marginLeft: 60,
				width:276,
				height:1,
				backgroundColor:"black",
				opacity:0.2,
				marginTop:15
			}} />
		</div>
	}
}
	

export default class GoogleBuildInApp extends Component {
	render() {
		const {t,l} = this.props
		return <div style={{
			position:"absolute",
			left: 0,
			top: 0,
			width:360,
			height: global.isMobile? (1362 + 180) : (1260 + 180),
			fontSize:16,
		}}>
			
			<img src={require('./img/logo.jpg')} style={{
				position:"absolute",
				left: 24,
				top: 32,
				width:32,
				height:32
			}} />
			<div style={{
				position:"absolute",
				left: 24,
				top: 96,
				width:360 - 48,
				height:100,
			}}>
				<span style={{
					fontWeight:"bold"	
				}}>Google Applications</span>
				<br/>
				<br/>
				<span>You can choose to install and use the following applications on your phone.</span>
				<br/>
				<br/>
				<span>If you want to learn more, you can tap on each application.</span>
			</div>
			<div style={{
				position:"absolute",
				top:270,
			}}>
				{Data.map((_,i) => <Row data={_} key={i}/>)}
			</div>
		
		</div>
	}

}



// WEBPACK FOOTER //
// ./src/Comp/GoogleBuildInApp.js